"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _mobxReact = require("mobx-react");

var _ = require("../..");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require("./InfoBanner.css");

var _styles = {
  "container": "InfoBanner__container___3gqLK",
  "warning": "InfoBanner__warning___2P6S8",
  "error": "InfoBanner__error___a6aUO",
  "content": "InfoBanner__content___2RoUs"
};

const styles = _bind.default.bind(_styles);

const InfoBanner = (0, _mobxReact.observer)(({
  className,
  dataTestId,
  title,
  subtitle,
  type = 'default',
  ctaLabel,
  ctaOnClick,
  image
}) => {
  const composed_classname = (0, _bind.default)(styles('container', type), className);
  return _react.default.createElement(_.Flex, {
    "data-testid": dataTestId,
    className: composed_classname,
    gap: 16,
    alignItems: 'center'
  }, image && _react.default.createElement("img", {
    src: image,
    alt: title
  }), _react.default.createElement(_.Flex, {
    direction: 'column',
    gap: 8,
    className: styles('content')
  }, _react.default.createElement(_.Heading, {
    text: title,
    size: 18,
    variant: 'medium',
    marginBottom: 0
  }), _react.default.createElement(_.Text, {
    text: subtitle,
    size: 13
  }), ctaLabel && ctaOnClick && _react.default.createElement(_.Button, {
    label: ctaLabel,
    onClick: ctaOnClick,
    small: true,
    flexAlignSelf: 'flex-start'
  })), ctaLabel && ctaOnClick && _react.default.createElement(_.Button, {
    label: ctaLabel,
    onClick: ctaOnClick,
    small: true
  }));
});
var _default = InfoBanner;
exports.default = _default;